import { slateGQLFields } from './slate.fields.js';
export const navigationSlatesGQLFields = (fields) => `
  header {
    ${slateGQLFields(fields)}
  }
  sidebar1 {
    ${slateGQLFields(fields)}
  }
  sidebar2 {
    ${slateGQLFields(fields)}
  }
  footer {
    ${slateGQLFields(fields)}
  }
`;
//# sourceMappingURL=navigationSlates.fields.js.map